export default __webpack_public_path__ + "static/media/vanPhongImg2.a6244113.jpeg";